// extracted by mini-css-extract-plugin
module.exports = {"root":"AddSponsorLogoForm_root__ZaXAp"};